module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN ParaOverride-6",
    attrs: {
      "id": "_idParaDest-4",
      "xml:lang": "en-GB"
    }
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Copyright © 2017 by Mark Bowden")])]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Postscript © 2018 by Mark Bowden")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Jacket design by Michael Patrick Dudding")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space ParaOverride-7"
  }, [_vm._v("Jacket photograph © Rolls Press/Popperfoto/Getty")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Maps © 2017 by Matthew Ericson")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("An excerpt from “Cheating the Reaper” is reprinted from "), _c('br'), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Praying at the Altar")]), _vm._v(" by W. D. Ehrhart, Adastra Press, 2017, by permission of the author; "), _c('br'), _vm._v("“Ballad of the Green Berets,” words and music by Barry Sadler and Robin Moore, "), _c('br'), _vm._v("copyright © Music Music Music Inc., 1963, 1964 & 1966. Permission given by Lavona Sadler.")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Photo credits are as follows: Photo 1.1 (Che Thi Mung): Courtesy of Che Thi Mung. Photos 1.2 (Frank Doezema), 2.1 (Jim Coolican): Courtesy of Jim Coolican and Fred Drew. Photo 1.3 (Nguyen Dac Xuan): Courtesy of Nguyen Dac Xuan. 1.4 (President Johnson and General William Westmoreland): Bettmann/Getty Images. 2.2 (Gordon Batcheller): Official Marine Corps Photo. 2.3 (Chuck Meadows): Courtesy of Chuck Meadows. 2.4 (Alfredo “Freddie” Gonzalez): Official Marine Corps Photo A419730, courtesy of the Marine Corps History Division. 3.1 (MACV press pass): Courtesy of Gene Roberts. 3.2 (Jim and Tuy-Cam Bullington): Courtesy of Jim and Tuy-Cam Bullington. Photos 3.3 (Tran Cao Van Street), 5.4 (raising the American flag): Rolls Press/Popperfoto/Getty Images. 3.4 (Mike Downs): Courtesy of Mike Downs. 4.1 (Ernie Cheatham): Courtesy of John Salvati. 4.2 (Catherine Leroy): Photo by François Mazure, published in "), _c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("LIFE Magazine ")]), _vm._v("(February 16, 1968). 4.3 (Ray Smith): Courtesy of Ray Smith. 4.4 (Bob Helvey): Courtesy of Charles Krohn and Robert Helvey. 5.1 (Civilians in Hue): Photo by Kyoichi Sawada, UPI. 5.2 (Ron Christmas): Courtesy of Ron Christmas. 5.3 (Andy Westin): Courtesy of Andy Westin. Photo 6.1 (Walter Cronkite): Everett Collection Inc/Alamy Stock Photo. 6.2 (Bob Thompson): Courtesy of John Olson, source unknown. Photos 6.3 (Dong Ba Tower), 7.2 (the Citadel): © John Olson. Photo 6.4 (Steve “Storyteller” Berntson): Courtesy of Steve Berntson. Photo 7.1 (James Vaught): Photo Courtesy of James J. Wilson, Sgt. E 5, B Co., 5/7 Cav. 1967-68.")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("The paperback edition includes eight new photos taken by reporter David Greenway while he was embedded with Delta Company First Battalion, Fifth Marines, in Hue from February 15 to 19, 1968. Photo pages 2, 94, 156, 216, 294, 396: All photos and captions courtesy of David Greenway.")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Every effort has been made to trace copyright holders and to obtain their permission for the use of copyright material. The publisher apologizes for any errors or omissions and would be grateful if notified of any corrections that should be incorporated in future reprints or editions of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Scanning, uploading, and electronic distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, and do not participate in or encourage electronic piracy of copyrighted materials. Your support of the author’s rights is appreciated. Any member of educational institutions wishing to photocopy part or all of the work for classroom use, or anthology, should send inquiries to Grove Atlantic, 154 West 14th Street, New York, NY 10011 or "), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_vm._v("permissions@groveatlantic.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Published simultaneously in Canada")])]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA"
  }, [_c('span', {
    staticClass: "CharOverride-6"
  }, [_vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA ParaOverride-8"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("Text Design by Norman Tuttle"), _c('br'), _vm._v("This book was set in Dante MT with ITC New Baskerville "), _c('br'), _vm._v("by Alpha Design & Compostion of Pittsfield, NH")])]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("First Grove Atlantic hardcover edition: June 2017")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space ParaOverride-7"
  }, [_vm._v("First Grove Atlantic paperback edition: April 2018")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Library of Congress Cataloguing-in-Publication data is available for this title.")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("ISBN 978-0-8021-2790-7")]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("eISBN 978-0-8021-8924-0")])]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA"
  }, [_c('span', {
    staticClass: "CharOverride-8"
  }, [_vm._v("an imprint of Grove Atlantic")])]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("154 West 14th Street")])]), _vm._v(" "), _c('p', {
    staticClass: "TVT_Title_verso_page_text_SA"
  }, [_c('span', {
    staticClass: "CharOverride-7"
  }, [_vm._v("New York, NY 10011")])]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_vm._v("Distributed by Publishers Group West")]), _vm._v(" "), _c('p', {
    staticClass: "CR-space"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_vm._v("groveatlantic.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18306806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook_V45573.vue
// module id = 72
// module chunks = 0